/**
 * PromptBinder - minimal binder to attach PromptEditor to buttons
 * Use this instead of the legacy EditPromptFix modules.
 */

import { PromptEditor } from './PromptEditor.js';

export function bindPromptEditors(scope = document) {
  const buttons = scope.querySelectorAll('.prompt-edit-btn:not([data-pe-bound="true"])');
  if (!buttons || buttons.length === 0) return 0;
  
  // Reuse a single instance
  const editor = window.promptEditor instanceof PromptEditor ? window.promptEditor : new PromptEditor();
  window.promptEditor = editor;

  buttons.forEach(btn => {
    btn.dataset.peBound = 'true';
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      // Prevent other legacy listeners from firing and closing modals
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      e.stopPropagation();
      const key = btn.dataset.promptKey;
      const name = btn.dataset.promptName || key || 'Prompt';
      try { editor.open(key, name); }
      catch (err) { console.error('PromptEditor open failed:', err); }
    });
  });
  return buttons.length;
}

export default { bindPromptEditors };
